// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__rx3yI","footer":"ModalCreateQualiphyProcedure_footer__2jGw5","additionData":"ModalCreateQualiphyProcedure_additionData__9bfNS"};